module.exports = __webpack_public_path__ + "static/img/role0015.acc54b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role0015.jpg
// module id = BnnY
// module chunks = 1